import React, { useState, useEffect } from "react";
import axios from "axios";
import BGImg1 from "../../assets/img/bg/about-bg.png";
import { Link } from "react-router-dom";
import { baseURL, kullaniciId } from "../../App";
import { useGlobalState } from "../../useGlobalState";

const About = () => {
  const [hakkimizda, setHakkimizda] = useState(null);

  useEffect(() => {
    try {
      axios
        .get(`${baseURL}items/hakkinda_sayfasi?fields=*.*&filter[kullanici][_eq]=${kullaniciId}`)
        .then((response) => {
          // Verinin doğru formatta olup olmadığını kontrol et
          if (response.data) {
            // Veriyi state'e set etme
            setHakkimizda(response.data.data);
          } else {
            console.error("Invalid data format received from Directus.");
          }
        })
        .catch((error) => {
          console.error("Error fetching data from Directus:", error);
        });
    } catch (error) {
      console.error("An error occurred in useEffect:", error);
    }
  }, []);

  const { globalState, setGlobalState } = useGlobalState();

  return (
    <>
      <section
        className="about-area about-p pt-120 pb-120 p-relative fix"
        style={{
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundImage: `url(${BGImg1})`,
        }}
      >
        <div className="container">
          {hakkimizda && hakkimizda[0]?.translations?.filter(e => e.languages_code === globalState.lang)[0] && (
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div
                  className="s-about-img p-relative  wow fadeInLeft animated"
                  data-animation="fadeInLeft"
                  data-delay=".4s"
                >
                  {/* <img src={`${baseURL}assets/${about.image?.id}`} alt="" /> */}
                  <img src={`${baseURL}assets/${hakkimizda[0].hakkinda_resim?.id}`} alt="" />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div
                  className="about-content s-about-content  wow fadeInRight  animated"
                  data-animation="fadeInRight"
                  data-delay=".4s"
                >
                  <div className="about-title second-title pb-25">
                    <h5>{hakkimizda[0].translations?.filter((b) => b.languages_code === globalState.lan)[0]?.kapak_yazi}</h5>
                    <h3>{hakkimizda[0].translations?.filter((b) => b.languages_code === globalState.lang)[0]?.baslik_1}</h3>
                  </div>
                  <p>
                    {hakkimizda[0].translations?.filter((b) => b.languages_code === globalState.lang)[0]?.aciklama_1}
                  </p>
                  <div className="slider-btn mt-20">
                    <Link to={hakkimizda[0].translations?.filter((a) => a.languages_code === globalState.lang)[0]?.link} className="btn ss-btn smoth-scroll">
                      {hakkimizda[0].translations?.filter((b) => b.languages_code === globalState.lang)[0]?.link_Yazi}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default About;
